// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAlertsEwiErrorTriangle_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.43892 1.07458C5.69102 0.641807 6.30898 0.641808 6.56108 1.07458L11.9086 10.2544C12.1649 10.6945 11.8518 11.25 11.3475 11.25H0.652495C0.148193 11.25 -0.164899 10.6945 0.0914194 10.2544L5.43892 1.07458Z" class="svg-bg"/>
  <path d="M3 6.07992L4.07992 5L8.75958 9.67964L7.67966 10.7596L3 6.07992Z" class="svg-fg"/>
  <path d="M3 9.67965L7.67966 5.00001L8.75958 6.07993L4.07992 10.7596L3 9.67965Z" class="svg-fg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.2519 1.43277C7.58803 0.855743 8.41197 0.855743 8.7481 1.43277L15.8781 13.6726C16.2199 14.2593 15.8024 15 15.13 15H0.869994C0.197591 15 -0.219866 14.2593 0.121893 13.6726L7.2519 1.43277Z" class="svg-bg"/>
  <path d="M5 8.125L6.125 7L11 11.875L9.875 13L5 8.125Z" class="svg-fg"/>
  <path d="M5 11.875L9.875 7.00001L11 8.12501L6.125 13L5 11.875Z" class="svg-fg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.8778 1.64916C11.382 0.783614 12.618 0.783615 13.1222 1.64916L23.8172 20.0089C24.3298 20.8889 23.7036 22 22.695 22H1.30499C0.296386 22 -0.329798 20.8889 0.182839 20.0089L10.8778 1.64916Z" class="svg-bg"/>
  <path d="M8 11.5L9.5 10L16 16.5L14.5 18L8 11.5Z" class="svg-fg"/>
  <path d="M8 16.5L14.5 10L16 11.5L9.5 18L8 16.5Z" class="svg-fg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.5038 2.89645C15.1761 1.70118 16.8239 1.70118 17.4962 2.89645L31.7562 28.2504C32.4397 29.4657 31.6048 31 30.26 31H1.73999C0.395181 31 -0.439731 29.4657 0.243785 28.2504L14.5038 2.89645Z" class="svg-bg"/>
  <path d="M11 16.875L12.875 15L21 23.125L19.125 25L11 16.875Z" class="svg-fg"/>
  <path d="M11 23.125L19.125 15L21 16.875L12.875 25L11 23.125Z" class="svg-fg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M30.2488 5.17397C31.0094 3.79551 32.9906 3.79551 33.7512 5.17397L62.3635 57.0338C63.0989 58.3668 62.1347 60 60.6123 60H3.38765C1.86528 60 0.901074 58.3668 1.6365 57.0338L30.2488 5.17397Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32.0121 36.984L24.7556 29.7275L20.8672 33.6159L28.1237 40.8724L20.8848 48.1113L24.7739 52.0004L32.0128 44.7615L39.252 52.0007L43.1404 48.1123L35.9012 40.8731L43.1586 33.6156L39.2696 29.7266L32.0121 36.984Z" class="svg-fg"/>
</svg>
`;
/**
 * IconAlertsEwiErrorTriangle is a generated icon component.
 */
let IconAlertsEwiErrorTriangle = IconAlertsEwiErrorTriangle_1 = class IconAlertsEwiErrorTriangle extends IconBaseElement {
    render() {
        return html `${IconAlertsEwiErrorTriangle_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAlertsEwiErrorTriangle.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconAlertsEwiErrorTriangle = IconAlertsEwiErrorTriangle_1 = __decorate([
    customElement('zui-icon-alerts-ewi-error-triangle')
], IconAlertsEwiErrorTriangle);
export { IconAlertsEwiErrorTriangle };
